enum Env {
  dev = 'dev',
  stage = 'stage',
  prod = 'production',
}

export const isStageOrProductionEnvironment = [Env.stage, Env.prod].includes(String(process.env.REACT_APP_ENV) as Env);

export const isProductionEnvironment = Env.prod === process.env.REACT_APP_ENV;
